import { FILTERED_PRODUCT_PROPS } from "@/utils";
export const excludedProps = [
  "tags",
  "categories_ids",
  ...FILTERED_PRODUCT_PROPS,
];
